import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { saveUserId, saveAuthToken } from '../../utils/cookies';
import Button from '../../components/ui/Button';

const AUTH_REDIRECT_STORAGE_KEY = 'prepxai_auth_redirect';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = searchParams.get('token');
    const userId = searchParams.get('userId');
    const onboarded = searchParams.get('onboarded');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError('Google authentication failed. Please try again.');
      setLoading(false);
      setTimeout(() => {
        navigate('/login');
      }, 8081);
      return;
    }

    if (token && userId) {
      // Save userId and token
      saveUserId(userId);
      saveAuthToken(token);

      const storedRedirect = sessionStorage.getItem(AUTH_REDIRECT_STORAGE_KEY);
      if (storedRedirect) {
        sessionStorage.removeItem(AUTH_REDIRECT_STORAGE_KEY);
      }
      const redirectTo = storedRedirect || searchParams.get('redirect') || '/interview-setup';

      // Redirect to interview setup or onboarding
      if (onboarded === 'true') {
        navigate(redirectTo);
      } else {
        navigate('/onboarding');
      }
    } else {
      setError('Authentication failed. Missing token or user ID.');
      setLoading(false);
      setTimeout(() => {
        navigate('/login');
      }, 8081);
    }
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Completing authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 relative overflow-hidden">
      {/* Premium Header Background */}
      <div className="absolute top-0 left-0 right-0 h-[450px] bg-gradient-to-b from-emerald-50 via-emerald-50/20 to-transparent pointer-events-none z-0" />
      <div className="w-full max-w-md bg-card border border-border rounded-2xl p-6 sm:p-8 shadow-lg text-center relative z-10">
        {error ? (
          <>
            <div className="text-destructive text-lg font-semibold mb-4">Authentication Error</div>
            <p className="text-muted-foreground mb-6">{error}</p>
            <Button onClick={() => navigate('/login')} variant="default">
              Go to Login
            </Button>
          </>
        ) : (
          <>
            <div className="text-primary text-lg font-semibold mb-4">Success!</div>
            <p className="text-muted-foreground mb-6">Redirecting to dashboard...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
